@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "../../utils/mixins/mixins.scss";

:host {
  display: flex;
}

button {
  padding: 0;
  min-width: 0;
  width: $icon-xl;
  height: $icon-xl;
  flex-shrink: 0;
  border-radius: 50%;
  user-select: none;
  cursor: pointer;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: baseline;
  text-align: center;
  overflow: visible;
  box-sizing: border-box;
  position: relative;
  background: none;

  &:focus-visible {
    outline: auto;
  }

  &:disabled {
    pointer-events: none;
  }
}

.portal-icons {
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: var(--color-foreground-de-emp);
  user-select: none;
  margin: 0;
  border-radius: 50%;
  line-height: 0px;

  .portal-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &::after {
    @include after-background-effect();
    border-radius: 50%;
    user-select: none;
  }

  &.primary:not(.disabled):not(.transparent) {
    color: var(--color-primary);
    &:hover,
    &:focus:not(.hideFocus) {
      color: var(--color-primary-hover);
      background-color: var(--color-hover);
    }
    &:active {
      color: var(--color-primary-hover);
      background-color: var(--color-secondary-pressed);
    }
  }
  &:not(.disabled):not(:disabled) {
    &:hover,
    &:focus:not(.hideFocus) {
      &::after {
        background-color: var(--color-icon-default);
        opacity: 0.12;
      }
    }
    &:active {
      &::after {
        background-color: var(--color-icon-default);
        opacity: 0.24;
      }
    }
  }

  &.inherit:not(.disabled):not(:disabled) {
    color: inherit;
    &:hover,
    &:focus:not(.hideFocus) {
      color: inherit;
      background-color: var(--color-hover);
    }
    &:active {
      color: inherit;
      background-color: var(--color-secondary-pressed);
    }
  }

  &.transparent:not(.disabled):not(:disabled) {
    &:hover {
      color: var(--color-foreground-emp);
      background-color: inherit;
    }
    &:active {
      color: var(--color-foreground);
      background-color: inherit;
    }
    &.primary {
      color: var(--color-primary);
      &:hover {
        color: var(--color-primary-hover);
      }
      &:active {
        color: var(--color-primary-hover);
      }
    }
  }

  &.disabled,
  &:disabled {
    opacity: 0.6;
    cursor: default;
    color: var(--color-foreground-disable);
  }

  &.md {
    height: 40px;
    width: 40px;
  }
  &.sm {
    height: 32px;
    width: 32px;
  }
  &.lg {
    height: 48px;
    width: 48px;
  }
  &.xl {
    height: 56px;
    width: 56px;
  }
}
